import { Selector } from "@ngxs/store";

import { VehicleInfoState, VehicleInfoStateModel } from "./vehicle-info.state";
import { VehicleInfo } from "../../core/models/vehicle-info.model";
import { IRequestsNestedState } from "../interfaces/requests.interface";

export class VehicleInfoGetterState {
  @Selector([VehicleInfoState])
  static getCurrentVehicleInfo(state: VehicleInfoStateModel): VehicleInfo {
    return state.entities[state.currentVehicleId];
  }

  @Selector([VehicleInfoState])
  static getSaveVehicleInfoPutRequestState(
    state: VehicleInfoStateModel
  ): IRequestsNestedState {
    return state.saveVehicleInfoPutRequestState;
  }
}
